module.exports = __webpack_public_path__ + "cc32302e47be0c7267919daf7a090952.svg";